import { render, staticRenderFns } from "./particles.vue?vue&type=template&id=5cc6622c&lang=true&"
import script from "./particles.vue?vue&type=script&lang=js&"
export * from "./particles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports